"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.alertsAdapter = void 0;
// (C) 2021-2022 GoodData Corporation
var toolkit_1 = require("@reduxjs/toolkit");
var sdk_model_1 = require("@gooddata/sdk-model");
exports.alertsAdapter = toolkit_1.createEntityAdapter({
    selectId: function (alert) { return sdk_model_1.objRefToString(alert.ref); },
});
//# sourceMappingURL=alertsEntityAdapter.js.map